import { render, staticRenderFns } from "./AccessSuccess.vue?vue&type=template&id=c87b2916&"
import script from "./AccessSuccess.vue?vue&type=script&lang=js&"
export * from "./AccessSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports